import { render } from "./newsletter-signin.vue?vue&type=template&id=8ad53084"
import script from "./newsletter-signin.vue?vue&type=script&lang=js"
export * from "./newsletter-signin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__